import React from 'react';
import PropTypes from 'prop-types';
import DefaultPicture, {
  propTypes as pictureProps,
} from '../../../components/01_atoms/DefaultPicture';
import { useSelector } from 'react-redux';
import ProductPrice from '../../ProductPrice';
import AddToBasketButton from '../../AddToBasketButton';
import ProductBadge from '../../ProductBadge';

import styles from './index.module.scss';

const BBProductSection = ({ productId, title, description, alignment, showCta, image }) => {
  const products = useSelector((state) => state.productsStorage.gifts);
  const product = products[productId];

  return (
    <div className={`bb ${styles['bb-product-section']}`}>
      <div className={'container'}>
        <div
          className={`${styles['bb-product-section__wrapper']} ${styles[`bb-product-section__wrapper--${alignment}`]} ${styles[`bb-product-section__wrapper--${showCta ? 'cta' : 'no-cta'}`]}`}
        >
          <div className={styles['bb-product-section__image']}>
            <DefaultPicture {...image} />
            {showCta && <ProductBadge product={products[productId]} />}
          </div>
          <div className={styles['bb-product-section__content']}>
            {showCta && <h1 className={styles['bb-product-section__title']}>{title}</h1>}
            {!showCta && <h2 className={styles['bb-product-section__title']}>{title}</h2>}
            {showCta && (
              <div className={styles['bb-product-section__price']}>
                <ProductPrice product={product} />
              </div>
            )}
            {showCta && product.type === 'gifts_bundle' && (
              <div className={styles['bb-product-section__bundle_products']}>
                {product.giftsInBundle.map((productInBundleID) => (
                  <div
                    key={productInBundleID}
                    className={styles['bb-product-section__bundle_product']}
                  >
                    {products[productInBundleID].image && (
                      <DefaultPicture {...products[productInBundleID].image} />
                    )}
                    <div>{products[productInBundleID].title}</div>
                  </div>
                ))}
              </div>
            )}
            <div
              className={styles['bb-product-section__description']}
              dangerouslySetInnerHTML={{ __html: description }}
            />
            {showCta && (
              <div className={styles['bb-product-section__cta']}>
                <AddToBasketButton product={product} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

BBProductSection.propTypes = {
  productId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  alignment: PropTypes.string.isRequired,
  showCta: PropTypes.bool,
  image: PropTypes.shape(pictureProps),
};

export default BBProductSection;
